import axiosInstance from '../axiosInstance';

const unwrap = (request) =>
    request
        .then((response) => response?.data)
        .catch((error) => {
            throw error?.response?.data ?? error;
        });

export const getLogFiles = () => unwrap(axiosInstance.get('/LogViewer/GetLogFiles'));

export const getLogEvents = (params) =>
    unwrap(
        axiosInstance.get('/LogViewer/GetLogEvents', {
            params: {
                fileId: params.fileId,
                cursor: params.cursor || undefined,
                pageSize: params.pageSize,
                search: params.search || undefined,
                level: params.level || undefined,
                exceptionsOnly: params.exceptionsOnly || undefined
            }
        })
    );

export const getLogEvent = (eventId) =>
    unwrap(axiosInstance.get(`/LogViewer/GetLogEvent/${encodeURIComponent(eventId)}`));
